import { render, staticRenderFns } from "./InfoRegister.vue?vue&type=template&id=1cbd6563"
import script from "./InfoRegister.vue?vue&type=script&lang=js"
export * from "./InfoRegister.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/SysClass-Web-App/SysClass-Web-App/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1cbd6563')) {
      api.createRecord('1cbd6563', component.options)
    } else {
      api.reload('1cbd6563', component.options)
    }
    module.hot.accept("./InfoRegister.vue?vue&type=template&id=1cbd6563", function () {
      api.rerender('1cbd6563', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/sys/course/InfoRegister.vue"
export default component.exports